<template>
  <SpanComponent v-if="help && position === 'top'" v-tooltip.top="help" />
  <SpanComponent v-else-if="help && position === 'bottom'" v-tooltip.bottom="help" />
  <SpanComponent v-else-if="help && position === 'right'" v-tooltip.right="help" />
  <SpanComponent v-else-if="help && position === 'left'" v-tooltip.left="help" />
</template>

<script setup lang="ts">
import SpanComponent from './FormKitHelpSpan.vue'

withDefaults(defineProps<{ help: string; position?: 'top' | 'bottom' | 'right' | 'left' }>(), {
  position: 'top',
})
</script>
